export default "__VITE_ASSET__58a6bb7a__"